<style></style>

<template>
    <div class="my_progress">
        <h2 class="lighter">
            My Progress
            <a :href="fullProgressUrl" class="btn btn-orange-blue full-progress text-white">View Full Progress</a>
        </h2>
        <div id="program-progress-chart">
            <div class="progress_bar_graph_outer_wrapper">
                <div class="progress_bar_graph_wrapper scrolling shadowright">
                    <div class="progress_bar_graph">
                        <program-progress-bar 
                            v-for="module in modules" 
                            :key="module.id"
                            :assessments="getAssessmentsForModule(module)"
                            :module="module"
                            :survey-cutoffs="surveyCutoffs[module.id]"
                        >
                        </program-progress-bar>
                        
                        <div class="progress_bar_graph_grid left"></div>
                        <div class="progress_bar_graph_grid right"></div>                  
                    </div>
                    <div class="progress_bar_graph_labels">
                        <div class="x_label">Room For Improvement</div>
                        <div class="x_label">Making Progress</div>
                        <div class="x_label text-primary"><strong>Leading the Way!</strong></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="graph_directions">
            Scroll for more
            <span class="page-next"></span>
        </div>
    </div>
</template>

<script>
    import ProgramProgressBar from './ProgramProgressBar'
    import Auth from '../../auth.js'

    export default {
        components: {
            ProgramProgressBar
        },
        props: {
            program: {
                required: true,
                type: Object
            },
            assessments: {
                required: true,
                type: Array
            },
            modules: {
                required: true,
                type: Array
            },
            surveyCutoffs: {
                required: true,
                type: Object
            }        
        },
        data() {
            return {}
        },
        computed: {
            fullProgressUrl: function () {
                if (Auth.is('program-user')) {
                    return this.$basePath+'/my-progress'
                }
                return this.$basePath+'/my-progress/'+this.program.id
            }
        },
        methods: {
            getAssessmentsForModule(module) {
                return this.assessments.filter( (ass) => {
                   return module.id == ass.survey.module_id;
                });
            }
        }
    
}
</script>